import React from "react";
// import "../../styles/page-styles/Analysis-style.css";

const QuestionAnalysis = () => {
  // Mock data 
  const focusAreas = [
    {
      category: "ADMINISTRATION AND HEALTH INFOMATICS",
      topics: [{ name: "Death certification", score: "0/7" }],
    },
    {
      category: "DERMATOLOGY",
      topics: [
        { name: "Periorficial dermatitis", score: "0/7" },
        { name: "Seborrhoeic dermatitis in adults", score: "0/11" },
        { name: "Squamous cell carcinoma of the skin", score: "0/7" },
      ],
    },
  ];

  return (
    <div className="analysis-container">
      <div className="analysis-wrapper">
        <header className="analysis-header">
          <h1 className="analysis-heading1">
            PassMedicine Performance Analysis
          </h1>
        </header>

        <div className="analysis-card">
          <h2 className="analysis-heading2">Performance analysis</h2>
          <p className="analysis-paragraph">
            PassMedicine builds an internal model of your knowledge based on
            question performance to date.
          </p>

          <div className="analysis-visual-example">
            <div className="analysis-heatmap-header">
              <div className="analysis-heatmap-grid">
                <div className="analysis-yellow-col"></div>
                <div className="analysis-blue-col"></div>
                <div className="analysis-green-col-container">
                  {Array(15)
                    .fill(null)
                    .map((_, i) => (
                      <div key={i} className="analysis-green-col"></div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="analysis-card">
          <h2 className="analysis-heading2">Areas to focus on</h2>
          <p className="analysis-paragraph">
            There are thousands of data points in your knowledge model - we've
            analyzed them to highlight areas to focus on:
          </p>

          <div className="analysis-table-container">
            <table className="analysis-table">
              <thead>
                <tr className="analysis-table-header">
                  <th className="analysis-table-header-cell">Topic</th>
                  <th className="analysis-table-header-cell">Score</th>
                  <th className="analysis-table-header-cell">View</th>
                </tr>
              </thead>
              <tbody>
                {focusAreas.map((area, index) => (
                  <React.Fragment key={index}>
                    <tr className="analysis-category-header">
                      <td colSpan={3} className="analysis-category-header-cell">
                        {area.category}
                      </td>
                    </tr>

                    {area.topics.map((topic, topicIndex) => (
                      <tr
                        key={`topic-${index}-${topicIndex}`}
                        className="analysis-topic-row"
                      >
                        <td className="analysis-topic-cell">{topic.name}</td>
                        <td className="analysis-score-cell">
                          <div className="analysis-score-box">
                            {topic.score}
                          </div>
                        </td>
                        <td className="analysis-notes-cell">
                          <button className="analysis-notes-button">
                            Notes
                          </button>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionAnalysis;
